import ioc from '@Framework/ioc';
export default function installPlugins(Vue) {
    ioc.get('config.plugins').forEach(({ plugin, options }) => {
        Vue.use(plugin, options);
    });
}
